export enum MY_ACCOUNT_ROUTES {
  DASHBOARD = "/account/Container/DashboardContainer?customerMobile=",
}
